import React, { FC } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ImageTypeEnum } from '../imageSettingsTypes';
import ImageListComponent from '../../../core/components/imageList/ImageListComponent';
import cageBackgroundUrl from '../../../images/cage-min.jpg';
import lineBackgroundUrl from '../../../images/line-min.jpg';
import emptyBackgroundUrl from '../../../images/empty.jpg';
import { AppStateTypes } from '../../../store/appStateTypes';
import { imageSettingsChangeImageType } from '../state/controller';
import { PanelSubSectionComponent } from '../../../core/components/panel/PanelComponent';

const IMAGE_URLS = {
  [ImageTypeEnum.CAGE]: cageBackgroundUrl,
  [ImageTypeEnum.LINE]: lineBackgroundUrl,
  [ImageTypeEnum.EMPTY]: emptyBackgroundUrl,
  [ImageTypeEnum.CUSTOM]: '',
};

const ImageTypeContainer: FC = () => {
  const dispatch = useDispatch();

  const { imageType } = useSelector((state: AppStateTypes) => state.imageSettings);

  const images = Object.values(ImageTypeEnum).filter((image) => image !== ImageTypeEnum.CUSTOM).map((image) => ({
    url: IMAGE_URLS[image],
    isActive: image === imageType,
    onClick: () => {
      dispatch(imageSettingsChangeImageType(image));
    },
  }));

  return (
        <PanelSubSectionComponent>
            <p>Выберите фон</p>
            <ImageListComponent images={images} />
        </PanelSubSectionComponent>
  );
};

export default ImageTypeContainer;
